import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { useTransferMoneyContext } from '../hooks/useTransferMoneyContext';

const fetchMaxAchRelationships = async (clientId: string): Promise<number> => {
  return authFetch(
    urlWithParams('/Consumer/AchRelationships/GetMaximumAchRelationships', {
      clientId,
    }),
  );
};

export const useMaxAchRelationshipsQuery = () => {
  const { clientId } = useTransferMoneyContext();

  return useQuery(
    queryKeys.maxAchRelationships(clientId),

    () => fetchMaxAchRelationships(clientId),

    {
      cacheTime: 0,
    },
  );
};
